/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module HttpPolicySetModule
 */

import {
    MessageItem,
    RepeatedMessageItem,
} from 'ajs/modules/data-model/factories';

import {
    withEditChildMessageItemMixin,
} from 'ajs/modules/data-model/mixins/with-edit-child-message-item.mixin';

import {
    IHTTPSecurityPolicy,
    IHTTPSecurityRule,
} from 'generated-types';

import { HTTPSecurityPolicy } from 'object-types';
import { HTTPSecurityRuleConfigItem } from './http-security-rule.config-item.factory';

type THTTPSecurityPolicyPartial = Omit<IHTTPSecurityPolicy, 'rules'>;

interface IHTTPSecurityPolicyConfig extends THTTPSecurityPolicyPartial {
    rules?: RepeatedMessageItem<HTTPSecurityRuleConfigItem>;
}

/**
 * @description
 *
 *   HTTPPolicySet security rules Message Item.
 *
 * @author Rohit Gaikwad, Umesh Chovatiya
 */
export class HTTPSecurityPolicyConfigItem extends
    withEditChildMessageItemMixin(MessageItem)<IHTTPSecurityPolicyConfig> {
    constructor(args = {}) {
        const extendedArgs = {
            objectType: HTTPSecurityPolicy,
            ...args,
        };

        super(extendedArgs);
    }

    /**
     * Opens Create AuthenticationRule Modal.
     */
    public addSecurityRule(): void {
        this.addChildMessageItem({
            field: 'rules',
        });
    }

    /**
     * Merge match field as null if match does not exist in Security item for edit.
     */
    public editSecurityRuleModal(messageItem: MessageItem<IHTTPSecurityRule>): void {
        if (!messageItem.config.match) {
            messageItem.mergeConfig({ match: null });
        }

        this.addChildMessageItem({
            field: 'rules',
            messageItem,
        });
    }

    /**
     * Return the HTTP Security Rule Config Item.
     */
    public get rules(): RepeatedMessageItem<HTTPSecurityRuleConfigItem> {
        return this.config.rules;
    }
}
